import { NgClass } from '@angular/common';
import { Component, ElementRef, inject } from '@angular/core';
import { AgendasComponent } from 'components/core/agendas/agendas.component';
import { CompanySearchComponent } from 'components/core/company-search/company-search.component';
import { NotificationsComponent } from 'components/core/notifications/notifications.component';
import { IconComponent } from 'components/layout/icon/icon.component';
import { NotificationStatus } from 'enums/NotificationStatus';
import { NotificationModel } from 'models/generated/Communication.Api.Models.Notification';
import { ScreenAuthenticatorComponent } from 'components/core/screen-authenticator/screen-authenticator.component';
import { UserService } from 'services/user.service';
import { CustomCredentials } from 'constants/CustomCredentials';
import { NavigationService } from 'services/navigation.service';
import { CompanyDashboardComponent } from 'components/company/company-dashboard.component';
import { ButtonComponent } from 'components/input/button/button.component';

@Component({
	selector: 'left-panel',
	templateUrl: './left-panel.component.html',
	styleUrls: ['./left-panel.component.scss'],
	imports: [NgClass, IconComponent, CompanySearchComponent, NotificationsComponent, AgendasComponent, ScreenAuthenticatorComponent, ButtonComponent]
})
export class LeftPanelComponent {

	expanded?: 'expanded' | 'large-expanded';
	searchActivated = false;
	showNotifications = false;
	showAgendas = false;
	showScreenAuthenticator = false;
	notificationsCount?: string;
	overdueAgendasCount?: string;
	hasAccessToScreenAuthenticator: boolean;

	private readonly element = inject(ElementRef<HTMLElement>);
	private readonly navigationService = inject(NavigationService);

	constructor(userService: UserService) {
		const customCredentials = userService.getCustomCredentials();
		this.hasAccessToScreenAuthenticator = CustomCredentials.values.filter(cc => cc.startsWith('Screen')).some(cc => customCredentials.includes(cc));
	}

	checkClickOutside(eventTarget: EventTarget | null) {
		if (!eventTarget || !(eventTarget instanceof Node) || !this.element.nativeElement.contains(eventTarget)) {
			this.activateSearch(false);
			this.activateNotifications(false);
			this.activateAgendas(false);
			this.activateScreenAuthenticator(false);
		}
	}

	activateSearch(active: boolean = true) {
		this.expanded = undefined;
		this.searchActivated = active;
		if (active) this.expanded = 'expanded';
	}

	activateNotifications(active: boolean = true) {
		this.expanded = undefined;
		this.showNotifications = active;
		if (active) this.expanded = 'large-expanded';
	}

	activateAgendas(active: boolean = true) {
		this.expanded = undefined;
		this.showAgendas = active;
		if (active) this.expanded = 'large-expanded';
	}

	activateScreenAuthenticator(active: boolean = true) {
		this.expanded = undefined;
		this.showScreenAuthenticator = active;
		if (active) this.expanded = 'large-expanded';
	}

	updateOverdueAgendasCount(count: number) {
		this.overdueAgendasCount = count > 99 ? "!" : count > 0 ? count.toString() : undefined;
	}

	updateNotificationsCount(notifications: NotificationModel[]) {
		var notificationsCount = notifications.filter(notification => notification.status == NotificationStatus.New).length;
		this.notificationsCount = notificationsCount > 99 ? "!" : notificationsCount > 0 ? notificationsCount.toString() : undefined;
	}

	navigateToCompany(companyId: string) {
		this.navigationService.refreshView(CompanyDashboardComponent).then(component => {
			component.companyId = companyId;
		});
	}
}
